import {Box, Grid, Typography} from "@material-ui/core";
import {
  MerchantDatepicker,
  MerchantInput,
  MerchantSelect,
  MerchantTextarea,
  MerchantRequestError, MerchantUploadInput
} from "../../../../../../../helpers/InputsHelpers";
import MerchantDropdown from "../../../../../../../layouts/components/helpers/MerchantDropdown";
import {BtnBlackOutlined, BtnBlueFilled, Ripple} from "../../../../../../../helpers/Buttons";
import ContactIcon from "../../../../../../../icons/Contact";
import {FormWrapper, FormFooterMerchant} from "../../../../../../../helpers/FormHandlers";
import React from "react";
import {backLocation, pushLocation} from "../../../../../../../../router";
import {LINK_PBL, LINK_PBL_DETAILS} from "../../../../../../../../constants/links";
import onSubmit from "../../utils/onSubmit";
import newPaymentLinkSchemaCtor from "../../utils/newPaymentLinkSchemaCtor";
import getTime from "mn-utils/time";
import ButtonBack from "../../../../../../../dumb/Button/BackB";
import Caption from "../../../../../../../dumb/Caption/C";
import numberHandle from "../../../../../../../../utils/numberHandle";
import trim from "mn-utils/trim";
import {apiV2KycDocumentUpload} from "../../../../../../../../api/merchant/kyc";
import {
  apiInvoiceGetNextInvoiceNumber,
  apiV2PayByLinkAttachRemove
} from "../../../../../../../../api/merchant/payByLink";
import onSave from "../../utils/onSave";
import UpdateIcon from "@material-ui/icons/Update";
import {ENDPOINT_MERCHANT_INVOICE_DOC_UPLOAD} from "../../../../../../../../constants/api";
import * as links from "../../../../../../../../constants/links";
import {MerchantPageHeader} from "../../../../../../../helpers/Display";

const SelectContact = ({contactsList, formCtx}) => {
  return (
    <Box sx={{display: 'flex', alignItems: 'flex-end'}}>
      <Box sx={{flex: 1}}>
        <MerchantInput
          label="Customer Name"
          name="customer"
          formCtx={formCtx}
        />
      </Box>
      <Box sx={{width: '4.5rem', ml: '2rem'}}>
        <MerchantDropdown
          id="customer-select"
          btnProps={{
            component: BtnBlackOutlined,
            heightMedium: true,
            square: true
          }}
          PaperProps={{style: {width: 320}}}
          itemsList={contactsList.map((el, i) => (
            <Ripple
              key={i}
              onClick={() => formCtx.onChange('customer', el.name)}
            >
              {el.name}
            </Ripple>
          ))}
          hideCaret
        >
          <ContactIcon width="2.2rem" />
        </MerchantDropdown>
      </Box>
    </Box>
  )
}

const AmountWithCode = ({fieldProps = {}, selectProps = {}, formCtx}) => (
  <Box sx={{display: 'flex', alignItems: 'flex-end'}}>
    <Box sx={{flex: 1}}>
      <MerchantInput
        {...fieldProps}
        formCtx={formCtx}
      />
    </Box>
    <Box sx={{width: '13rem', ml: '2rem'}}>
      <MerchantSelect
        {...selectProps}
        formCtx={formCtx}
      />
    </Box>
  </Box>
);

const InvoiceIdInput = ({formCtx}) => {
  const [loadingNextId, setLoadingState] = React.useState(false);
  const name = 'invoice';

  const getNewId = () => {
    setLoadingState(true);

    apiInvoiceGetNextInvoiceNumber()
      .then((res) => (res || {}).number)
      .then((val) => {
        formCtx.onChange(name, val);
      }).finally(() => setLoadingState(false))
  }

  return (
    <MerchantInput
      name={name}
      label="Order ID"
      formCtx={formCtx}
      disabled={loadingNextId}
      endAdornment={(
        <Ripple onClick={getNewId}>
          <UpdateIcon />
        </Ripple>
      )}
    />
  )
}

export default (props) => {
  const {
    id = '',
    customersList,
    assetsList,
    assetsLimits,
    defaultData
  } = props;

  const MIN_DATE = new Date(getTime() + 1000 * 60 * 60 * 24);

  const onResult = ({id}) => pushLocation({
    path: `${LINK_PBL_DETAILS}/${id}?pblIsNew=true`,
  });

  return (
    <FormWrapper
      data={defaultData}
      onSubmit={(data) => onSubmit(data, id)}
      onResult={onResult}
      schema={newPaymentLinkSchemaCtor({assetsLimits, assetsList})}
      resultModalData={[
        'Payment link sent',
        'You can view the request status<br/>in the transaction history',
      ]}
    >{
      (formCtx) => {
        return (
          <>
            <MerchantPageHeader
              title="Pay by Link"
              backFN={() => (
                pushLocation({
                  path: LINK_PBL,
                })
              )}
              formCtx={formCtx}
            />
            <Box mt="2rem">
              <Grid container spacing={4}>
              <Grid item md={6} xs={12}>
                <SelectContact
                  contactsList={customersList}
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <InvoiceIdInput
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantInput
                  name="company"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <AmountWithCode
                  fieldProps={{
                    name: 'amount',
                    onChangeHandlers: [numberHandle]
                  }}
                  selectProps={{
                    name: 'currency',
                    items: assetsList
                  }}
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantInput
                  name="address"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantDatepicker
                  label="Due Date"
                  name="expirationDate"
                  format="dd.MM.yyyy"
                  minDate={MIN_DATE}
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantInput
                  name="email"
                  type="email"
                  formCtx={formCtx}
                  onChangeHandlers={[trim]}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantInput
                  name="phone"
                  type="tel"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantTextarea
                  name="description"
                  maxLength={15000}
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantUploadInput
                  name="files"
                  uploadName="invoice_attach"
                  multiple

                  apiUpload={apiV2KycDocumentUpload}
                  apiRemove={(data) => {

                    console.log(data);

                    const params = {
                      id: id || data.id,
                      file_id: data.id
                    }

                    return (
                      apiV2PayByLinkAttachRemove(params)
                    )
                  }}
                  uploadUrl={ENDPOINT_MERCHANT_INVOICE_DOC_UPLOAD}

                  formCtx={formCtx}
                />
              </Grid>
              <Grid item md={6} xs>
                <FormFooterMerchant
                  spacing={2}
                  submitBtnData={{
                    text: 'Send Link',
                    changesCheckDisabled: !!id,
                    formCtx
                  }}
                  additionalBtnsList={[
                    {
                      text: 'Save Changes',
                      onClick: () => onSave({id, formCtx})
                    }
                  ]}
                />
              </Grid>
            </Grid>
            </Box>
          </>
        )
      }
    }</FormWrapper>
  )
}
